
import { useState } from 'react';
import { useToast } from '@/hooks/use-toast';
import { sendFormByMailto } from '@/utils/mailtoUtils';
import { ApplicationFormData } from './ApplicationFormSchema';

export const useApplicationFormSubmit = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { toast } = useToast();

  const submitApplication = async (data: ApplicationFormData) => {
    setIsSubmitting(true);
    
    try {
      console.log('Soumission de la candidature:', data);
      
      const success = sendFormByMailto(
        'contactgfe@groupefabre.com',
        `Nouvelle candidature : ${data.firstName} ${data.lastName} - ${data.jobPosition}`,
        {
          'Prénom': data.firstName,
          'Nom': data.lastName,
          'Email': data.email,
          'Téléphone': data.phone,
          'Poste souhaité': data.jobPosition,
          'Niveau d\'expérience': data.experience,
          'Lettre de motivation': data.motivation,
        },
        (formData) => {
          return `Nouvelle candidature pour le poste : ${data.jobPosition}

=== INFORMATIONS PERSONNELLES ===
Prénom : ${formData['Prénom']}
Nom : ${formData['Nom']}
Email : ${formData['Email']}
Téléphone : ${formData['Téléphone']}

=== CANDIDATURE ===
Poste souhaité : ${formData['Poste souhaité']}
Niveau d'expérience : ${formData['Niveau d\'expérience']}

=== LETTRE DE MOTIVATION ===
${formData['Lettre de motivation']}

---
Candidature envoyée depuis le site web Groupe Fabre Environnement
Date : ${new Date().toLocaleDateString('fr-FR')} à ${new Date().toLocaleTimeString('fr-FR')}`;
        }
      );

      if (success) {
        toast({
          title: "Client de messagerie ouvert !",
          description: "Votre candidature a été préparée dans votre client de messagerie. N'oubliez pas d'envoyer l'email.",
        });
        return true;
      } else {
        throw new Error('Erreur lors de l\'ouverture du client de messagerie');
      }
    } catch (error) {
      console.error('Erreur lors de la soumission:', error);
      toast({
        title: "Erreur",
        description: "Une erreur est survenue lors de l'ouverture du client de messagerie. Veuillez réessayer.",
        variant: "destructive",
      });
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    isSubmitting,
    submitApplication
  };
};
